import { render } from "./LetterArea.vue?vue&type=template&id=d524402c&scoped=true"
import script from "./LetterArea.vue?vue&type=script&lang=js"
export * from "./LetterArea.vue?vue&type=script&lang=js"

import "./LetterArea.vue?vue&type=style&index=0&id=d524402c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d524402c"]])

export default __exports__